<div class="vch-backdrop" (click)="handleOffcanvasClose()"></div>

<div class="offcanvas offcanvas-end show vch-panel" (hidden.bs.offcanvas)="handleOffcanvasClose()" tabindex="-1"
    id="reportOrderDetail" aria-labelledby="offcanvasRightLabel" aria-modal="true" role="dialog"
    style="visibility: visible;">

    <div class="vch-header">
        <div class="vch-advisor">
            <div class="vch-avatar">
                <img [src]="astrologerDetail?.profilePic || '/assets/image/modified.svg'" alt="advisor">
            </div>
            <div class="vch-advisor-info">
                <h2 class="vch-name">{{astrologerDetail?.astrologerName || 'Advisor'}}</h2>
                <div class="vch-sub">
                    <span class="vch-duration"><i class="fa-regular fa-clock"></i> {{chatDuration}} min</span>
                    <span class="vch-status" *ngIf="astrologerDetail?.chatOrderStatus">{{astrologerDetail?.chatOrderStatus}}</span>
                </div>
            </div>
        </div>
        <button type="button" (click)="handleOffcanvasClose()" class="vch-close btn-close" data-bs-dismiss="offcanvas"
            aria-label="Close"></button>
    </div>

    <div class="vch-body" #scrollMe>
        <div class="vch-divider"><span>Chat transcript</span></div>

        <div class="vch-row" *ngFor="let item of chatMessages"
            [ngClass]="item?.senderId==userId ? 'out' : 'in'">
            <div class="vch-bubble">
                <p>{{item?.chatMessage}}</p>
            </div>
        </div>
    </div>
</div>
